import Vue from 'vue'
import App from './App.vue'
import VueAnalytics from 'vue-analytics'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import Vuelidate from 'vuelidate'
import firebaseService from '@/services/firebase.service'
import socialSharing from 'vue-social-sharing'

Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(Vuelidate)
Vue.use(socialSharing)

Vue.use(VueAnalytics, {
  id: 'UA-122976831-2',
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

firebaseService.initializeFirebase(store)

const unsubscribe = firebaseService.onAuthStateChanged(firebaseUser => {
  new Vue({
    router,
    store,
    render: h => h(App),
    async created () {
      if (firebaseUser) {
        // get user data from custom backend
        const data = await store.dispatch('autoSignIn', { firebaseUser })
        if (process.env.NODE_ENV === 'production' && data) {
          window.Intercom('boot', {
            app_id: 'oail12jm',
            email: data.email,
            created_at: data.dateCreated
          })
        } else {
          window.Intercom('boot', {
            app_id: 'oail12jm'
          })
        }
      } else {
        window.Intercom('boot', {
          app_id: 'oail12jm'
        })
      }
    }
  }).$mount('#app')
  unsubscribe()
})
